import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from '@core/services/global.service';
import { AuthService } from 'src/app/core/services/authentication.service';

@Component({
  standalone: false,
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrl: './callback.component.scss',
})
export class CallbackComponent implements OnInit {
  private readonly authService: AuthService = inject(AuthService);
  private readonly GlobalService: GlobalService = inject(GlobalService);
  private readonly router: Router = inject(Router);

  /*
    Ce composant est appelé tout de suite après la réponse du SSO.
    On l'utilise pour charger les données nécessaires à l'application
  */

  public ngOnInit(): void {
    // Il est possible que le SSO ne soit pas encore prêt à répondre aux requêtes
    setTimeout(() => this.getConnect(), 2000); // On attend 2 secondes avant de charger les données
  }

  getConnect(): void {
    this.GlobalService.GlobalConnect().subscribe({
      next: (response) => {
        // On verifie si l'utilisateur est actif
        // Si l'utilisateur est actif, on le redirige vers la page d'accueil
        // Sinon on le redirige vers la page de connexion
        if (response?.active) {
          this.authService.isConnected.set(true);
          this.router.navigate(['home']);
        } else {
          this.GlobalService.clearUserData();
          this.authService.isConnected.set(false);
          this.router.navigate(['error401']);
        }
      },
      error: (error) => {
        this.GlobalService.clearUserData();
        this.authService.isConnected.set(false);
        console.error('Error:', error);
        this.router.navigate(['error401']);
      },
    });
  }
}
